import slice, { authenticate } from './auth.slice';
export { authenticate };
export default slice.reducer;
